export default "__VITE_ASSET__CwWvrvcN__"